export class ProfileImageUpload {
    name: string;
    url: string;
    file: File;
    progress: number;
    constructor(file: File) {
      this.file = file;
    }
}



// WEBPACK FOOTER //
// /app/src/app/core/models/profile-image-upload.ts